<template>
  <v-menu left>
    <slot name="activator" slot="activator"></slot>
    <v-list dense>

      <v-list-tile :key="i" :ripple="!opt.disabled" @click="clickTile(opt, i, $event)" v-for="(opt, i) in options">
        <!--<v-list-tile-action class="pr-0">-->
        <v-icon :color="opt.disabled ? 'grey' : ''" class="mr-4" small>{{opt.icon}}</v-icon>
        <!--</v-list-tile-action>-->
        <v-list-tile-title
          :class="[opt.disabled ? dark ? 'grey--text text--darken-1':'grey--text text--lighten-1':'']"
          class="pr-4">{{opt.label}}
        </v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'LOptionList',
  props: {
    options: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    dark () {
      return this.$vuetify.dark
    }
  },
  methods: {
    clickTile (opt, i, e) {
      // console.log('emit', opt)
      if (opt.disabled) {
        e.preventDefault()
        e.stopPropagation()
        return
      }
      if (opt.event) {
        this.$emit(opt.event)
      }
      else {
        this.$emit('click:' + i)
      }
    }
  }
}
</script>

<style scoped>

</style>
